// extracted by mini-css-extract-plugin
export default {"container":"KImp7D","user-email":"VvMBwR","userEmail":"VvMBwR","logout-wrapper":"wAuGTD","logoutWrapper":"wAuGTD","logout":"wgykCW"};